"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _colors = require("HubStyleTokens/colors");

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UIIconButton = _interopRequireDefault(require("UIComponents/button/UIIconButton"));

var _UIMultiColumn = _interopRequireDefault(require("UIComponents/layout/UIMultiColumn"));

var _UIMultiColumnGroup = _interopRequireDefault(require("UIComponents/layout/UIMultiColumnGroup"));

var _UIMultiColumnItem = _interopRequireDefault(require("UIComponents/layout/UIMultiColumnItem"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UITextInput = _interopRequireDefault(require("UIComponents/input/UITextInput"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UILockedFeature = _interopRequireDefault(require("ui-addon-upgrades/decorators/UILockedFeature"));

var _UILock = _interopRequireDefault(require("ui-addon-upgrades/icons/UILock"));

var _ValidationUtils = require("lead-flows-ui/utils/ValidationUtils");

var RuleRow =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(RuleRow, _Component);
  (0, _createClass2.default)(RuleRow, null, [{
    key: "propTypes",
    get: function get() {
      return {
        hasQueryParamAccess: _react.PropTypes.bool.isRequired,
        hasExclusionAccess: _react.PropTypes.bool.isRequired,
        hasContainsAccess: _react.PropTypes.bool.isRequired,
        hasMore: _react.PropTypes.bool.isRequired,
        index: _react.PropTypes.number.isRequired,
        isDefault: _react.PropTypes.bool.isRequired,
        isParam: _react.PropTypes.bool.isRequired,
        isWhiteList: _react.PropTypes.bool.isRequired,
        paramKey: _react.PropTypes.string.isRequired,
        onValidate: _react.PropTypes.func.isRequired,
        onChange: _react.PropTypes.func.isRequired,
        onDelete: _react.PropTypes.func.isRequired,
        startsWith: _react.PropTypes.bool.isRequired,
        isContains: _react.PropTypes.bool.isRequired,
        isExactMatch: _react.PropTypes.bool.isRequired,
        value: _react.PropTypes.string.isRequired,
        newlyAdded: _react.PropTypes.bool.isRequired
      };
    }
  }]);

  function RuleRow(props) {
    var _this;

    (0, _classCallCheck2.default)(this, RuleRow);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(RuleRow).call(this, props));
    var hasMore = props.hasMore,
        index = props.index,
        isParam = props.isParam,
        startsWith = props.startsWith,
        isContains = props.isContains,
        isExactMatch = props.isExactMatch,
        isWhiteList = props.isWhiteList,
        paramKey = props.paramKey,
        value = props.value,
        newlyAdded = props.newlyAdded;
    _this.buildOptions = _this.buildOptions.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleInputChange = _this.handleInputChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleContentChange = _this.handleContentChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleDelete = _this.handleDelete.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleTypeChange = _this.handleTypeChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.selectContentValue = _this.selectContentValue.bind((0, _assertThisInitialized2.default)(_this));
    _this.tooltipInputHandler = _this.tooltipInputHandler.bind((0, _assertThisInitialized2.default)(_this));
    var contentValue = Boolean(index || hasMore || !isWhiteList || isExactMatch || value.length) ? 'is' : 'all';

    if (startsWith) {
      contentValue = 'begins';
    } else if (isContains) {
      contentValue = 'contains';
    }

    _this.state = {
      contentValue: contentValue,
      hasKey: Boolean(props.paramKey),
      ruleValue: isParam ? 'queryParameters' : 'website',
      isUrlInputValid: isExactMatch || startsWith ? (0, _ValidationUtils.isValidDynoUrl)(value, newlyAdded) : true,
      isKeyInputValid: Boolean(paramKey),
      isValueInputValid: isParam ? Boolean(value) : true,
      isContainsInputValid: isContains ? Boolean(value) : true,
      mouseOverInput: false,
      inputFocused: false
    };
    return _this;
  }

  (0, _createClass2.default)(RuleRow, [{
    key: "getLangKey",
    value: function getLangKey(suffix) {
      return "leadFlowEditor.leadFlowOptionsEditor.targetingOptions." + suffix;
    }
  }, {
    key: "buildOptions",
    value: function buildOptions(step) {
      var _this$props = this.props,
          hasMore = _this$props.hasMore,
          hasContainsAccess = _this$props.hasContainsAccess,
          hasQueryParamAccess = _this$props.hasQueryParamAccess,
          index = _this$props.index,
          isWhiteList = _this$props.isWhiteList;
      var containsBadge = hasContainsAccess ? null : _react.default.createElement(_UILock.default, null);
      var contentOptions = [{
        text: _I18n.default.text(this.getLangKey('options.content.all')),
        value: 'all',
        disabled: Boolean(index || hasMore)
      }, {
        text: _I18n.default.text(this.getLangKey('options.content.is')),
        value: 'is'
      }, {
        text: _I18n.default.text(this.getLangKey('options.content.begins')),
        value: 'begins'
      }, {
        text: _I18n.default.text(this.getLangKey('options.content.contains')),
        value: 'contains',
        badge: containsBadge
      }];
      var queryParamBadge = hasQueryParamAccess ? null : _react.default.createElement(_UILock.default, null);
      var typeOptions = [{
        text: _I18n.default.text(this.getLangKey('options.type.website')),
        value: 'website'
      }, {
        text: _I18n.default.text(this.getLangKey('options.type.queryParameters')),
        value: 'queryParameters',
        badge: queryParamBadge
      }];
      if (!isWhiteList) contentOptions.splice(0, 1);
      return step === 'type' ? typeOptions : contentOptions;
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(event) {
      var isUrl = event.target.className.indexOf('targeting-option__url-input') > -1;
      var isKey = event.target.className.indexOf('key') > -1;
      var isContains = event.target.className.indexOf('targeting-option__contains-input') > -1;

      if (isUrl) {
        this.setState({
          isUrlInputValid: (0, _ValidationUtils.isValidDynoUrl)(event.target.value)
        });
      } else if (isKey) {
        this.setState({
          isKeyInputValid: Boolean(event.target.value)
        });
      } else if (isContains) {
        this.setState({
          isContainsInputValid: Boolean(event.target.value)
        });
      } else {
        this.setState({
          isValueInputValid: Boolean(event.target.value)
        });
      }

      this.props.onValidate();
    }
  }, {
    key: "handleInputChange",
    value: function handleInputChange(event) {
      var _this$props2 = this.props,
          index = _this$props2.index,
          isParam = _this$props2.isParam,
          isWhiteList = _this$props2.isWhiteList,
          onChange = _this$props2.onChange,
          paramKey = _this$props2.paramKey,
          startsWith = _this$props2.startsWith,
          isContains = _this$props2.isContains;
      var value = event.target.value;
      var isKey = event.target.className.indexOf('key') > -1;
      var key = isKey ? value : paramKey;
      var data = isKey ? this.props.value : value;
      var _this$state = this.state,
          ruleValue = _this$state.ruleValue,
          contentValue = _this$state.contentValue;
      var ruleType = ruleValue === 'queryParameters' ? ruleValue : contentValue;
      if (isKey) this.setState({
        hasKey: Boolean(value)
      });
      onChange(data, isParam, isWhiteList, startsWith, isContains, ruleType, null, index, key);
    }
  }, {
    key: "handleContentChange",
    value: function handleContentChange(_ref) {
      var value = _ref.target.value;
      var _this$props3 = this.props,
          index = _this$props3.index,
          hasContainsAccess = _this$props3.hasContainsAccess,
          isParam = _this$props3.isParam,
          isWhiteList = _this$props3.isWhiteList,
          onChange = _this$props3.onChange,
          paramKey = _this$props3.paramKey,
          startsWith = _this$props3.startsWith,
          isContains = _this$props3.isContains,
          onValidate = _this$props3.onValidate;

      if (value === 'contains' && !hasContainsAccess) {
        var lockedFeature = document.getElementById('contains-lock-feature-button');
        lockedFeature.click();
        return;
      }

      this.setState({
        contentValue: value
      });
      onChange(this.props.value, isParam, isWhiteList, startsWith, isContains, value, null, index, paramKey);
      onValidate();
    }
  }, {
    key: "handleDelete",
    value: function handleDelete() {
      var _this$props4 = this.props,
          index = _this$props4.index,
          isParam = _this$props4.isParam,
          isWhiteList = _this$props4.isWhiteList,
          paramKey = _this$props4.paramKey,
          startsWith = _this$props4.startsWith,
          isContains = _this$props4.isContains,
          value = _this$props4.value;
      this.props.onDelete(value, isParam, isWhiteList, startsWith, isContains, index, paramKey);
    }
  }, {
    key: "handleTypeChange",
    value: function handleTypeChange(_ref2) {
      var value = _ref2.target.value;
      var _this$props5 = this.props,
          index = _this$props5.index,
          isParam = _this$props5.isParam,
          isWhiteList = _this$props5.isWhiteList,
          onChange = _this$props5.onChange,
          paramKey = _this$props5.paramKey,
          startsWith = _this$props5.startsWith,
          isContains = _this$props5.isContains,
          hasQueryParamAccess = _this$props5.hasQueryParamAccess;

      if (value === 'queryParameters' && !hasQueryParamAccess) {
        var lockedFeature = document.getElementById('query-param-lock-feature-button');
        lockedFeature.click();
        return;
      }

      this.setState({
        ruleValue: value
      });
      onChange(this.props.value, isParam, isWhiteList, startsWith, isContains, value, this.state.contentValue, index, paramKey);
    }
  }, {
    key: "tooltipInputHandler",
    value: function tooltipInputHandler() {
      var _this2 = this;

      return {
        onMouseEnter: function onMouseEnter() {
          return _this2.setState({
            mouseOverInput: true
          });
        },
        onMouseLeave: function onMouseLeave() {
          return _this2.setState({
            mouseOverInput: false
          });
        },
        onFocus: function onFocus() {
          return _this2.setState({
            inputFocused: true
          });
        },
        onBlur: function onBlur() {
          return _this2.setState({
            inputFocused: false
          });
        }
      };
    }
  }, {
    key: "shouldShowInputTooltip",
    value: function shouldShowInputTooltip() {
      var value = this.props.value;
      var _this$state2 = this.state,
          mouseOverInput = _this$state2.mouseOverInput,
          inputFocused = _this$state2.inputFocused;
      return value && mouseOverInput && !inputFocused;
    }
  }, {
    key: "selectContentValue",
    value: function selectContentValue() {
      var _this$props6 = this.props,
          isParam = _this$props6.isParam,
          startsWith = _this$props6.startsWith,
          isContains = _this$props6.isContains,
          value = _this$props6.value;
      if (isParam) return 'queryParameters';
      if (startsWith) return 'begins';
      if (isContains) return 'contains';
      if (value) return 'is';
      return this.state.contentValue;
    }
  }, {
    key: "maybeRenderContentType",
    value: function maybeRenderContentType() {
      var _this3 = this;

      var isParam = this.props.isParam;
      var selectedValue = this.selectContentValue();
      if (isParam) return null;
      return _react.default.createElement(_UISelect.default, {
        className: "targeting-option__select-rule short content",
        itemComponent: function itemComponent(_ref3) {
          var children = _ref3.children,
              className = _ref3.className,
              option = _ref3.option;
          return _react.default.createElement(_UITooltip.default, {
            disabled: !option.disabled,
            placement: "right",
            title: _I18n.default.text(_this3.getLangKey('options.content.allTooltip'))
          }, _react.default.createElement("span", {
            className: className
          }, children));
        },
        value: selectedValue,
        onChange: this.handleContentChange,
        options: this.buildOptions('content'),
        searchable: false
      });
    }
  }, {
    key: "maybeRenderDelete",
    value: function maybeRenderDelete() {
      var _this$props7 = this.props,
          isDefault = _this$props7.isDefault,
          isWhiteList = _this$props7.isWhiteList;
      if (isDefault && isWhiteList) return null;
      return _react.default.createElement(_UIIconButton.default, {
        className: "targeting-option__delete-button",
        onClick: this.handleDelete,
        placement: "right",
        use: "unstyled"
      }, _react.default.createElement(_UIIcon.default, {
        color: _colors.CALYPSO,
        name: "delete"
      }));
    }
  }, {
    key: "maybeRenderUrlInput",
    value: function maybeRenderUrlInput() {
      var _this$props8 = this.props,
          isParam = _this$props8.isParam,
          isContains = _this$props8.isContains,
          value = _this$props8.value;
      var validationMessage = this.state.isUrlInputValid ? '' : _I18n.default.text(this.getLangKey('enterValidUrl'));
      if (isParam || isContains || this.state.contentValue === 'all' && !value.length) return null;
      return _react.default.createElement(_UIFormControl.default, {
        className: "targeting-option__input",
        error: !this.state.isUrlInputValid,
        validationMessage: validationMessage,
        onBlur: this.handleBlur
      }, _react.default.createElement(_UITooltip.default, {
        title: value,
        placement: "right",
        open: this.shouldShowInputTooltip()
      }, _react.default.createElement(_UITextInput.default, (0, _extends2.default)({
        error: !this.state.isUrlInputValid,
        className: "targeting-option__url-input",
        onChange: this.handleInputChange,
        value: value
      }, this.tooltipInputHandler()))));
    }
  }, {
    key: "maybeRenderContainsInput",
    value: function maybeRenderContainsInput() {
      var _this$props9 = this.props,
          isContains = _this$props9.isContains,
          value = _this$props9.value;
      if (!isContains) return null;
      var validationMessage = this.state.isContainsInputValid ? '' : _I18n.default.text(this.getLangKey('mustHaveValue'));
      return _react.default.createElement(_UIFormControl.default, {
        className: "targeting-option__input",
        error: !this.state.isContainsInputValid,
        onBlur: this.handleBlur,
        validationMessage: validationMessage
      }, _react.default.createElement(_UITooltip.default, {
        title: value,
        placement: "right",
        open: this.shouldShowInputTooltip()
      }, _react.default.createElement(_UITextInput.default, (0, _extends2.default)({
        error: !this.state.isContainsInputValid,
        className: "targeting-option__contains-input",
        onChange: this.handleInputChange,
        value: value
      }, this.tooltipInputHandler()))));
    }
  }, {
    key: "maybeRenderKeyInput",
    value: function maybeRenderKeyInput() {
      var _this$props10 = this.props,
          isParam = _this$props10.isParam,
          paramKey = _this$props10.paramKey,
          value = _this$props10.value;
      if (!isParam) return null;
      return _react.default.createElement(_UITextInput.default, {
        className: "targeting-option__input short key",
        error: Boolean(value.length) && !Boolean(paramKey.length),
        onBlur: this.handleInputBlur,
        onChange: this.handleInputChange,
        value: paramKey
      });
    }
  }, {
    key: "maybeRenderValueInput",
    value: function maybeRenderValueInput() {
      var _this$props11 = this.props,
          isParam = _this$props11.isParam,
          value = _this$props11.value;
      var hasKey = this.state.hasKey;
      if (!isParam) return null;
      return _react.default.createElement("span", {
        onBlur: this.handleBlur
      }, _react.default.createElement(_UITooltip.default, {
        title: value,
        placement: "right",
        open: this.shouldShowInputTooltip()
      }, _react.default.createElement(_UITextInput.default, (0, _extends2.default)({
        disabled: !hasKey,
        error: !this.state.isValueInputValid,
        className: "targeting-option__input value",
        onChange: this.handleInputChange,
        value: value
      }, this.tooltipInputHandler()))));
    }
  }, {
    key: "maybeRenderEqualSign",
    value: function maybeRenderEqualSign() {
      var isParam = this.props.isParam;
      if (!isParam) return null;
      return _react.default.createElement("span", {
        className: "targeting-option__equal"
      }, '=');
    }
  }, {
    key: "renderRuleSelect",
    value: function renderRuleSelect() {
      var isParam = this.props.isParam;
      var selectedValue = isParam ? 'queryParameters' : 'website';
      return _react.default.createElement(_UISelect.default, {
        className: "targeting-option__select-rule rule",
        itemComponent: function itemComponent(_ref4) {
          var children = _ref4.children,
              className = _ref4.className;
          return _react.default.createElement("span", {
            className: className
          }, children);
        },
        value: selectedValue,
        onChange: this.handleTypeChange,
        options: this.buildOptions('type'),
        searchable: false
      });
    }
  }, {
    key: "renderContainsLockFeature",
    value: function renderContainsLockFeature() {
      return _react.default.createElement(_UILockedFeature.default, {
        upgradeData: {
          app: 'lead-flows',
          screen: 'editor',
          uniqueId: 'advanced-targeting-options-contains',
          upgradeProduct: 'marketing-pro'
        },
        modalKey: "leadflows-targeting-contains",
        modalMountDelay: 0
      }, _react.default.createElement(_UIButton.default, {
        use: "unstyled",
        id: "contains-lock-feature-button"
      }));
    }
  }, {
    key: "renderQueryParamLockFeature",
    value: function renderQueryParamLockFeature() {
      return _react.default.createElement(_UILockedFeature.default, {
        upgradeData: {
          app: 'lead-flows',
          screen: 'editor',
          uniqueId: 'advanced-targeting-options-query-param',
          upgradeProduct: 'marketing-pro'
        },
        modalKey: "leadflows-targeting-query-params",
        modalMountDelay: 0
      }, _react.default.createElement(_UIButton.default, {
        use: "unstyled",
        id: "query-param-lock-feature-button"
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props12 = this.props,
          index = _this$props12.index,
          isWhiteList = _this$props12.isWhiteList;
      var arrowMessage = index ? this.getLangKey('arrow.or') : this.getLangKey('arrow.when');
      var list = isWhiteList ? 'show' : 'hide';
      return _react.default.createElement(_UIMultiColumn.default, {
        className: "targeting-option",
        id: "targeting-option-" + index + "-" + list
      }, _react.default.createElement(_UIMultiColumnGroup.default, null, _react.default.createElement(_UIMultiColumnItem.default, {
        className: "targeting-option__rule"
      }, _react.default.createElement("div", {
        className: "targeting-option__arrow"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: arrowMessage
      })), this.renderRuleSelect(), this.maybeRenderContentType(), this.maybeRenderUrlInput(), this.maybeRenderContainsInput(), this.maybeRenderKeyInput(), this.maybeRenderEqualSign(), this.maybeRenderValueInput(), this.maybeRenderDelete(), this.renderContainsLockFeature(), this.renderQueryParamLockFeature())));
    }
  }]);
  return RuleRow;
}(_react.Component);

exports.default = RuleRow;
module.exports = exports.default;